
import { defineComponent, ref } from 'vue';
import { ComponentName } from '@/classifications/api/configuration/components/ComponentName';
import { setupComponent } from '@/classifications/composables/setupComponent';

import InjectStyles from '@/common/components/InjectStyles.vue';
import Spinner from '@/common/components/Spinner.vue';

export default defineComponent({
  name: ComponentName.loadingIndicator,

  components: {
    InjectStyles,
    Spinner,
  },

  props: {
    instanceId: String,
  },

  setup(props) {
    const root = ref<HTMLElement>();

    const { componentName, isReady, isWebComponent, store, routeData } = setupComponent(
      root,
      props.instanceId,
    );

    return {
      root,
      componentName,
      isReady,
      isWebComponent,
      store,
      routeData,
    };
  },
});
